"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var workerImport_exports = {};
__export(workerImport_exports, {
  workerImport: () => workerImport
});
module.exports = __toCommonJS(workerImport_exports);
var import_url = require("url");
var import_path = require("path");
var cache = /* @__PURE__ */ new Map();
async function workerImport(relativePath, callerUrl) {
  var callerDir = (0, import_path.dirname)((0, import_url.fileURLToPath)(callerUrl));
  var absolutePath = (0, import_path.resolve)(callerDir, relativePath);
  var cacheKey = absolutePath;
  if (cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }
  var mjsPath = absolutePath.endsWith(".mjs") ? absolutePath : `${absolutePath}.mjs`;
  var mod = await import((0, import_url.pathToFileURL)(mjsPath).href);
  cache.set(cacheKey, mod);
  return mod;
}
//# sourceMappingURL=workerImport.js.map
